import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Box, Button, Grid, Typography } from "@mui/material";
import Step from '@mui/material/Step';
import StepContent from '@mui/material/StepContent';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useLocation, useNavigate } from "react-router-dom";
import { getOderDetail } from "src/api/getOderDetail";
import LogoQr from "src/assets/payment/logo-mb-qr.jpg";
import DetailQr from "src/assets/payment/qr-detail.png";
import { BANK_NAME } from "src/const/const-from-env";
import { messageTypeFee } from "src/const/message";
import useCheckMobile from "src/hook/useCheckMobile";
import PopupService from "src/utils/PopupService";
import { convertTotalAmount } from "src/utils/convert/totalAmount";
import { itemLocalstorage } from "../../const/itemLocalstorage";

const useStyle = makeStyles((theme) => {
  return {
    container: {
      paddingBottom: "24px",
      [theme.breakpoints.down("md")]: {
        paddingBottom: "8px",
      },
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      paddingBottom: "2rem",
      paddingTop: "4rem",
      [theme.breakpoints.down("md")]: {
        paddingBottom: 0,
        paddingTop: "2rem",
      },
    },
    imageType: {
      paddingLeft: "10px",
      height: "3rem",
      objectFit: "cover",
    },
    itemContainer: {
      width: "100%",
      textAlign: "center",
    },
    typePaymentText: {
      fontWeight: 600,
      [theme.breakpoints.down("md")]: {
        fontWeight: 700,
      },
    },
    containerContent: {
      width: "100%",
      margin: "0 auto",
      maxWidth: 650,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        maxWidth: "500px",
      },
    },
    contentQr: {
      display: "flex",
      justifyContent: "center",
      paddingBottom: 0,
      paddingTop: "0",
      [theme.breakpoints.down("md")]: {
        paddingBottom: 0,
        paddingTop: "0",
      },
    },
    contentQrImage: {
      width: "500px",
    }
  };
});
interface IForm {
  type: string;
  typePay: string;
  name: string | null;
  email: string | null;
  phone: string | number | null;
  user_email: string | null;
}

interface IParamsPage {
  frSystm: string;
  paymentId: string;
}

const checkAmountDataForm = (dataPayment?: any) => {
  switch (dataPayment?.policy?.feeType) {
    case "P001":
      return dataPayment?.policy?.initialPremium?.totalAmt || 0;
    case "P002":
      return dataPayment?.policy?.duePremium?.duePremiumInfo?.dueAmt || 0;
    case "P003":
      return dataPayment?.policy?.topUp?.amount || 0;
    case "P004":
      return dataPayment?.policy?.reInstate?.totalAmt || 0;
    case "P005":
      return dataPayment?.policy?.addRider?.totalAmt || 0;
    case "P006":
      return dataPayment?.policy?.changePaymentFrequency?.totalAmt || 0;
    default:
      break;
  }
}

const QrPayContent = (props) => {
  const { isCheckPayStatus } = props;
  const history = useHistory();
  const classes = useStyle();
  const isMobile = useCheckMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [isCopied, setIsCopied] = useState(false);


  const search = location.search;
  const searchParams = new URLSearchParams(search.substring(1));
  const entries = searchParams.entries();
  const params = paramsToObject(entries) as IParamsPage;

  function paramsToObject(entries) {
    const result = {};
    for (const [key, value] of entries) {
      // each 'entry' is a [key, value] tupple
      result[key] = value;
    }
    return result;
  }

  const [dataQrCode, setDataQrCode] = useState<any>([]);
  const [dataPayment, setDataPayment] = useState<any>();
  const [vietQRType, setVietQRType] = useState<any>();
  const handleBackInfoPay = () => {
    const data = localStorage.getItem('urlTypePay') ? localStorage.getItem('urlTypePay') : null;
    localStorage.setItem("QRCodeData", null);
    if (data) {
      openInCurrentTab(data);
    } else {
      navigate(-1);

    }
  }

  function openInCurrentTab(url) {
    let win = window.open(url, "_self");
    win.focus();
  }

  const getOrderDetailReq = async (orderId) => {
    return await getOderDetail(
      { orderId },
      localStorage.getItem('frSystm'),
      "QRGEN"
    )
  }
  function handleDownloadQrCode() {

    const a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + dataQrCode?.target; //Image Base64 Goes here
    a.download = "QR.png"; //File name Here
    a.click(); //Downloaded file

    if (window?.ReactNativeWebView) {
      window?.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: "downloadQrCode",
          data: dataQrCode?.target
        })
      )
    }
    if (window?.flutter_inappwebview) {
      window?.flutter_inappwebview?.callHandler(
        'ReactNativeWebView',
        JSON.stringify({
          type: "downloadQrCode",
          data: dataQrCode?.target
        })
      )
    }
  }

  useEffect(() => {
    const getRaw = (key: string) => {
      const v = localStorage.getItem(key);
      return v === null ? null : v;
    };

    const getJSON = (key: string) => {
      const raw = getRaw(key);
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    };

    const showErrorAndClose = () => {
      PopupService.instance.current.open({
        visible: true,
        content: "Đã có lỗi xảy ra vui lòng thử lại sau",
        onOk: () => {
          handleBackInfoPay();
          PopupService.instance.current.close();
        },
      });
    };

    const dataQRCode = getJSON("QRCodeData");
    const dataPayment = getJSON("dataPayment");
    const vietQRType = getRaw("vietQRType");

    if (!dataQRCode) {
      showErrorAndClose();
      return;
    }

    setDataQrCode(dataQRCode);
    setDataPayment(dataPayment);
    setVietQRType(vietQRType);

    // request order detail once immediately if we have an orderId
    const orderId = dataPayment?.policy?.orderId;
    if (orderId) {
      getOrderDetailReq(orderId).catch(() => {
          showErrorAndClose();
      });
    }

    // start polling for order status
    const intervalMs = parseInt(process.env.REACT_APP_TIME_INTERVAL_GET_ORDER || "5000", 10) || 5000;

    window.interval = setInterval(async () => {
      try {
        if (!isCheckPayStatus) return;
        if (!orderId) return;

        const res = await getOrderDetailReq(orderId);
        if (+res.data?.msgSts?.code === 200) {
          localStorage.setItem("dataPaymentQrGen", JSON.stringify(res.data?.data));
          window.location.href = dataPayment?.callbackUrl;
          clearInterval(window?.interval);
        }
      } catch (err) {
        showErrorAndClose();
        clearInterval(window?.interval);
      }
    }, intervalMs);

    return () => {
      clearInterval(window?.interval);
    };
  }, []);
  useEffect(() => {

    if (!isCheckPayStatus) {
      clearInterval(window?.interval);
    }
  }, [isCheckPayStatus]);


  function addParamToURL(url: string, paramName: string, paramValue: string | number) {

    // Kiểm tra xem URL đã chứa tham số chưa
    const separator = url.includes('?') ? '&' : '?' ;

    // Tạo URL mới với tham số đã được thêm (encode để an toàn)
    const newURL = `${url}${separator}${encodeURIComponent(paramName)}=${encodeURIComponent(String(paramValue))}`;

    return newURL;
  }

  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = (copyText: string) => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(copyText)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <div className={classes.containerContent}>
      <Stepper orientation="vertical">
        <Step key={0} active={false} expanded={true} sx={{}}>
          <StepLabel
          >
            <Typography variant="subtitle2" style={{ color: '#22313F', fontWeight: 'bold' }} gutterBottom>
              Tải ảnh về/Chụp ảnh QR
            </Typography>

          </StepLabel>
          <StepContent sx={{ paddingLeft: 0 }}>
            <Box sx={{ textAlign: "center", paddingLeft: 0 }}>
              <div className="flex items-center flex-col">
                {/* <img src={`data:image/png;base64, ${dataQrCode}`} alt="Qr" /> */}
                {
                 dataQrCode && dataQrCode?.target && <div
                    className="relative w-[200px] h-[200px]"
                    style={{
                      backgroundImage: `url("data:image/png;base64, ${dataQrCode?.target}")`,
                    }}
                  >
                    <div style={{
                      border: '1px solid #D9D9D9',
                      width: "162px",
                      height: "162px",
                      margin: "19px 19px"
                    }}>

                    </div>
                    <a
                      onClick={() => handleDownloadQrCode()}
                      style={{ position: 'absolute', bottom: '11px', right: '-15px', fontSize: '25px' }}
                    >
                      <SaveAltIcon fontSize="inherit" />
                    </a>
                    {/* <img src={QrTopLeftIcon} alt="" className="absolute top-5 left-5" />
                      <img src={QrTopRightIcon} alt="" className="absolute top-5 right-5" />
                      <img src={QrBottomLeftIcon} alt="" className="absolute bottom-5 left-5" />
                      <img src={QrBottomRightIcon} alt="" className="absolute bottom-5 right-5" />*/}
                    <img src={LogoQr} alt="" width={30} style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                    }} />

                  </div>
                }

                {/* <img src={DetailQr} alt="DetalQr" style={{ maxWidth: "205px" }} /> */}
                {/*<div className="text-center mt-2">*/}
                {/*  <div style={{ color: "#E60A32", fontSize: "13px" }}>QRCode chỉ có hiệu lực trong vòng 1 ngày</div>*/}
                  {/* <div className="text-[#007BDB] text-xs mb-2">Tên chủ TK: {BANK_NAME}</div>
                      <div className="text-[#007BDB] text-xs mb-2 font-bold">Số TK: {BANK_ACCOUNT}</div>
                      <div className="text-[#007BDB] text-xs">Ngân hàng TMCP Quân đội</div> */}
                {/*</div>*/}
              </div>
            </Box>
          </StepContent>
        </Step>
        <Step key={1} expanded={true} >
          <StepLabel
          >

            <Typography variant="subtitle2" style={{ color: '#22313F', fontWeight: 'bold' }} gutterBottom>
              Mở app ngân hàng và tải ảnh QR lên
            </Typography>

          </StepLabel>
          <StepContent>


          </StepContent>
        </Step>
        <Step key={2} expanded={true} >
          <StepLabel

          >

          </StepLabel>
          <StepContent>
            <Box sx={{ fontSize: "14px", marginTop: "-30px" }}>
              <Grid container spacing={0} >
                <Grid item xs={3}>
                  Nội dung:
                </Grid>
                <Grid item xs={7}>
                  {
                    dataQrCode?.transferContent && <Typography variant="subtitle2" gutterBottom>
                      {dataQrCode?.transferContent}
                    </Typography>
                  }
                  {
                    !dataQrCode?.transferContent && <Typography variant="subtitle2" gutterBottom>
                      {dataPayment?.policy?.idNumber}_{messageTypeFee[`${dataPayment?.policy?.feeType}`]}
                    </Typography>
                  }

                </Grid>
                <Grid item xs={2}>
                  <Button
                    color="success"
                    variant="outlined"
                    sx={{ padding: 0 }}
                    onClick={() => {
                      const content = `${dataPayment?.policy?.idNumber}_${messageTypeFee[dataPayment?.policy?.feeType]}`;
                      handleCopyClick(dataQrCode?.transferContent ?? content)
                    }}
                  >
                    COPY
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={0} mt={1}>
                <Grid item xs={3}>
                  Số tiền:
                </Grid>
                <Grid item xs={7}>
                  <Typography variant="subtitle2" gutterBottom>
                    {vietQRType === 'VIETQR' ? convertTotalAmount(dataQrCode?.amount) : convertTotalAmount(checkAmountDataForm(dataPayment))}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    color="success"
                    variant="outlined"
                    sx={{ padding: 0 }}
                    onClick={() => handleCopyClick(checkAmountDataForm(dataPayment))}
                  >
                    COPY
                  </Button>
                </Grid>
              </Grid>

              <Grid container spacing={0} mt={1}>
                <Grid item xs={3}>
                  Ngân hàng:
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="subtitle2" gutterBottom>
                    MB Bank
                  </Typography>
                </Grid>

              </Grid>
              <Grid container spacing={0}>
                <Grid item xs={3}>
                  Tên TK:
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body2" gutterBottom>
                    {BANK_NAME}
                  </Typography>
                </Grid>

              </Grid>
              {vietQRType !== "VIETQR" &&
                <Grid container spacing={0} mt={1}>
                  <Grid item xs={3}>
                    Số TK:
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="subtitle2" gutterBottom>
                      {dataQrCode?.bankAccount}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                        color="success"
                        variant="outlined"
                        sx={{ padding: 0 }}
                        onClick={() => handleCopyClick(dataQrCode?.bankAccount)}
                    >
                      COPY
                    </Button>
                  </Grid>
                </Grid>
              }
            </Box>

          </StepContent>
        </Step>

      </Stepper>
      <Box sx={{ mt: 2, textAlign: "justify" }}>
        {dataPayment?.policy?.feeType === 'P001' ?
            <>
              Chúc mừng Quý Khách đã hoàn thành yêu cầu mua bảo hiểm. Hợp đồng điện tử sẽ được MB Life phát hành sau khi quý <strong>khách thanh toán phí bảo hiểm thành công</strong>.
            </>
            :
            'Qúy Khách vui lòng liên hệ tới MB Life sau 05 ngày làm việc kể từ ngày nộp phí, Qúy khách không nhận được tin nhắn xác nhận thu phí từ Công ty.'
        }

      </Box>
      <div className="flex items-center justify-center pt-5 flex-col md:flex-row md:justify-between">

      </div>
    </div>
  );
};

export default QrPayContent;

